import { fetchPost, fetchDelete, fetchGet } from "./utilsFetch.js";

import {
    messageObject,
    cartCount,
    cartValue,
    isLoading,
    showReservationModal,
    locale,
} from "../stores.js";

import { getLocaleResource } from "../utils/locales.js";

export function getDecodedToken() {
    let tokenRaw = localStorage.getItem("token");
    if (tokenRaw) {
        let payload = tokenRaw.split(".")[1];
        let decoded = atob(payload);
        let token = JSON.parse(decoded);
        return token;
    }
}

export async function addToCart(sku, quantity, packaging) {
    isLoading.set(true);

    let qty = parseInt(quantity) || 0;

    // console.log(sku, qty, packaging);

    if (qty && qty < packaging) {
        isLoading.set(false);

        let message = `${getLocaleResource(
            locale,
            "minimumQuantityIs"
        )} ${packaging}`;

        // messageObject.update(() => ({
        //     showMessage: true,
        //     type: "error",
        //     message: message,
        // }));

        alert(message);

        return;
    }

    let result = await fetchPost("/api/cart/items", {
        sku,
        quantity: qty,
    });

    if (result.success == false) {
        messageObject.update(() => ({
            showMessage: true,
            type: "success",
            message: getLocaleResource(locale, "reservationSuccessful"),
        }));

        showReservationModal.set(true);
    } else {
        messageObject.update(() => ({
            showMessage: true,
            type: "success",
            message: getLocaleResource(locale, "addToCartSuccessful"),
        }));
    }

    await getCartCount();

    isLoading.set(false);
}

export async function removeFromCart(id) {
    isLoading.set(true);
    await fetchDelete(`/api/cart/items/${id}`);
    await getCartCount();
    isLoading.set(false);
}

export async function getCartCount() {
    let count = await fetchGet(`/api/cart/count`);
    cartCount.update(() => count.cartCount);
    cartValue.update(() => count.cartValue);
}

export function getDateTime() {
    let now = new Date();
    let dateTime = `${now.toISOString().split("T")[0]} ${now.toLocaleTimeString(
        "en-GB"
    )}`; // 2020-04-18 14:03:05
    return dateTime;
}
